export enum GlobalFormat {
  DateDash = 'YYYY-MM-DD',
  DateFlat = 'YYYYMMDD',
  DateHourMinute = 'YYYY-MM-DD HH:mm',
}
